const handleURLParams = ({ key, value, listOfKeyValues, location, history }) => {
  const urlParams = new URLSearchParams(location.search);

  if (listOfKeyValues && listOfKeyValues.length > 0) {
      listOfKeyValues.map(keyValue => {
          if (!keyValue.value) {
              urlParams.delete(keyValue.key);
          } else if (urlParams.get(keyValue.key)) {
              urlParams.set(keyValue.key, keyValue.value)
          } else {
              urlParams.append(keyValue.key, keyValue.value)
          }
      })
  } else {
      if (!value) {
          urlParams.delete(key);
      } else if (urlParams.get(key)) {
          urlParams.set(key, value)
      } else {
          urlParams.append(key, value)
      }
  }

  history.replace({ search: urlParams.toString() });
}

export default handleURLParams;